import classNames from 'classnames/bind';
import styles from './NotFound.module.scss';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

const cx = classNames.bind(styles);

function NotFound() {
    useEffect(() => {
        function drawVisor() {
            const canvas = document.getElementById('visor');
            const ctx = canvas.getContext('2d');

            ctx.beginPath();
            ctx.moveTo(5, 45);
            ctx.bezierCurveTo(15, 64, 45, 64, 55, 45);

            ctx.lineTo(55, 20);
            ctx.bezierCurveTo(55, 15, 50, 10, 45, 10);

            ctx.lineTo(15, 10);

            ctx.bezierCurveTo(15, 10, 5, 10, 5, 20);
            ctx.lineTo(5, 45);

            ctx.fillStyle = '#2f3640';
            ctx.strokeStyle = '#f5f6fa';
            ctx.fill();
            ctx.stroke();
        }

        const cordCanvas = document.getElementById('cord');
        const ctx = cordCanvas.getContext('2d');

        let y1 = 160;
        let y2 = 100;
        let y3 = 100;

        let y1Forward = true;
        let y2Forward = false;
        let y3Forward = true;

        function animate() {
            requestAnimationFrame(animate);
            // eslint-disable-next-line no-restricted-globals
            ctx.clearRect(0, 0, innerWidth, innerHeight);

            ctx.beginPath();
            ctx.moveTo(130, 170);
            ctx.bezierCurveTo(250, y1, 345, y2, 400, y3);

            ctx.strokeStyle = 'white';
            ctx.lineWidth = 8;
            ctx.stroke();

            if (y1 === 100) {
                y1Forward = true;
            }

            if (y1 === 300) {
                y1Forward = false;
            }

            if (y2 === 100) {
                y2Forward = true;
            }

            if (y2 === 310) {
                y2Forward = false;
            }

            if (y3 === 100) {
                y3Forward = true;
            }

            if (y3 === 317) {
                y3Forward = false;
            }

            y1Forward ? (y1 += 1) : (y1 -= 1);
            y2Forward ? (y2 += 1) : (y2 -= 1);
            y3Forward ? (y3 += 1) : (y3 -= 1);
        }

        drawVisor();
        animate();
    }, []);

    return (
        <div className={cx('wrapper')}>
            <div className={cx('moon')}></div>

            <div className={cx('error')}>
                <div className={cx('error__title')}>404</div>
                <div className={cx('error__subtitle')}>Not Found</div>
                <div className={cx('error__description')}>
                    Hmmm... Có vẻ như bạn bị lạc đường rồi!!! Hãy quay về trang chủ nhé!
                </div>
                <div className={cx('error__button-wrapper')}>
                    <Link to={'/'} className={cx('error__button')}>
                        Trang Chủ
                    </Link>
                </div>
            </div>

            <div className={cx('astronaut')}>
                <div className={cx('astronaut__backpack')}></div>
                <div className={cx('astronaut__body')}></div>
                <div className={cx('astronaut__body__chest')}></div>
                <div className={cx('astronaut__arm-left1')}></div>
                <div className={cx('astronaut__arm-left2')}></div>
                <div className={cx('astronaut__arm-right1')}></div>
                <div className={cx('astronaut__arm-right2')}></div>
                <div className={cx('astronaut__arm-thumb-left')}></div>
                <div className={cx('astronaut__arm-thumb-right')}></div>
                <div className={cx('astronaut__leg-left')}></div>
                <div className={cx('astronaut__leg-right')}></div>
                <div className={cx('astronaut__foot-left')}></div>
                <div className={cx('astronaut__foot-right')}></div>
                <div className={cx('astronaut__wrist-left')}></div>
                <div className={cx('astronaut__wrist-right')}></div>

                <div className={cx('astronaut__cord')}>
                    <canvas id="cord" height="500px" width="500px"></canvas>
                </div>

                <div className={cx('astronaut__head')}>
                    <canvas id="visor" width="60px" height="60px"></canvas>
                    <div className={cx('astronaut__head-visor-flare1')}></div>
                    <div className={cx('astronaut__head-visor-flare2')}></div>
                </div>
            </div>
        </div>
    );
}

export default NotFound;
